var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { create } from 'jss';
import { jssPreset } from '@mui/styles';
import JssProvider from 'react-jss/lib/JssProvider';
import App from "./containers/app/App";
import { ThemeProvider } from '@mui/material/styles';
import UltraTheme from "../assets/themes/ultra-theme";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchSignature } from "./containers/app/AppActions";
import { loadTranslations, setLocale } from 'react-redux-i18n';
import defaultTranslations from './i18n';

var jss = create(jssPreset());

var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main(props) {
        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.init = function () {
            var setProps = _this.props.setProps;

            var funcsFromNative = {
                onFinish: window.native.post.onFinish,
                onSave: window.native.get.onSave,
                onCancel: window.native.post.onCancel,
                setHeader: window.native.get.setHeader,
                fetchSignature: window.native.get.fetchSignature
            };
            // setProps && setProps({...window.signature, ...funcsFromNative}, true);
            _this.syncTranslations(window.signature.translationsObject);
        };

        _this.syncTranslations = function () {
            var translationsObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props = _this.props,
                loadTranslations = _this$props.loadTranslations,
                _this$props$locale = _this$props.locale,
                locale = _this$props$locale === undefined ? 'en' : _this$props$locale,
                setLocale = _this$props.setLocale,
                storeTranslation = _this$props.i18n.translations;

            var completeTranslations = Object.assign({}, defaultTranslations, storeTranslation, _defineProperty({}, locale, Object.assign({}, defaultTranslations[locale], storeTranslation[locale], translationsObject)));
            loadTranslations(completeTranslations);
            setLocale(locale);
        };

        _this.previous = function () {
            var previous = _this.props.app.previous;

            previous();
        };

        window.signature = Object.assign({}, window.signature, {
            previous: _this.previous,
            init: _this.init
        });
        return _this;
    }

    _createClass(Main, [{
        key: '__componentWillMount',
        value: function __componentWillMount() {
            var _this2 = this;

            var fetchSignature = this.props.fetchSignature;

            if (onSave) {
                var undefinedProps = ['fetchSignature'].filter(function (p) {
                    return !_this2.props[p];
                });
                if (undefinedProps.length > 0) {
                    console.warn('react-contact-info - Some props are not defined', JSON.stringify(undefinedProps));
                }
                this.syncTranslations(translationsObject);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var signature = this.props.signature;
            // if (!signature.initiated) return null;

            return React.createElement(
                ThemeProvider,
                { theme: UltraTheme },
                React.createElement(
                    JssProvider,
                    { jss: jss },
                    React.createElement(App, null)
                )
            );
        }
    }]);

    return Main;
}(Component);

var mapStateToProps = function mapStateToProps(_ref) {
    var signature = _ref.signature;
    return { signature: signature };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchSignature: fetchSignature }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/Main.js